<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.changeScreen();
    window.onresize = () => {
      return (() => {
        this.changeScreen();
      })();
    };
    console.log('浏览器语言', navigator.language)
    this.autoChangeLanguage();
  },
  methods: {
    changeScreen() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 420) {
        this.$store.commit('app/SET_CURRENTMEDIA', 1);
        this.$store.commit('app/SET_COLLAPSE', true);
      } else {
        this.$store.commit('app/SET_CURRENTMEDIA', 0)
        this.$store.commit('app/SET_COLLAPSE', false);
      }
    },
    autoChangeLanguage() {
      let lang = navigator.language.split('-')[0];
      switch (lang) {
        case "zh":
          this.$i18n.locale = "zh-CN";
          break;
        case "es":
          this.$i18n.locale = "es";
          break;
        case "cs":
          this.$i18n.locale = "cs";
          break;
        case "pt":
          this.$i18n.locale = "pt";
          break;
        default:
          this.$i18n.locale = "en";
          break;
      }
    }
  }
}
</script>

<style src="@/styles/normalize.scss">
#app {}
</style>



// WEBPACK FOOTER //
// src/App.vue